import { Link } from "react-router-dom";

export default function PageHero({ title, subtitle }) {
  return (
    <section className="relative overflow-hidden">

      {/* Background Overlay */}
      <div className="absolute inset-0 bg-[#064BA5]/90"></div>

      {/* Soft Gradient Accent */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/20 via-transparent to-black/20"></div>

      <div className="relative max-w-7xl mx-auto px-6 py-16 sm:py-20 text-center text-white">

        {/* Breadcrumb */}
        <p className="text-sm text-white/80 mb-3 tracking-wide">
          <Link to="/" className="hover:text-white transition">
            Home
          </Link>
          <Link to="/about" className="hover:text-white transition">
          <span className="mx-2">›</span>
          <span className="font-semibold">
            {title}
          </span>
          </Link>
        </p>
        

          {/* Page Title (Clickable) */}
        <Link to={"/about"}>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold hover:text-white/90 transition">
            {title}
          </h1>
        </Link>

        {/* Subtitle */}
        {subtitle && (
          <p className="mt-3 text-white/90 max-w-2xl mx-auto text-sm sm:text-base">
            {subtitle}
          </p>
        )}

        {/* Decorative Line */}
        <div className="mt-6 w-20 h-[3px] mx-auto bg-white rounded-full"></div>
      </div>

    </section>
  );
}
